module.exports = __webpack_public_path__ + "static/media/md-checkbox.88cf0db1.svg";